import React from "react";
import { AdminProducerAccountBalanceEditTemplate } from "themes/administration/producer/components";
import { AdminProducerAccountBalanceEditViewStore } from "administration/producer/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) => new AdminProducerAccountBalanceEditViewStore(rootStore, componentProps),
    "adminProducerAccountBalanceEditViewStore"
)
class AdminProducerAccountBalanceEdit extends React.Component {
    render() {
        return <AdminProducerAccountBalanceEditTemplate {...this.props} />;
    }
}

export default AdminProducerAccountBalanceEdit;
